if (!customElements.get("custom-tabs")) {
  customElements.define(
    "custom-tabs",
    class CustomTabs extends HTMLElement {
      constructor() {
        super();
        this.tabsContainer = this.querySelector(".tabs-container");
        this.tabsList = this.tabsContainer.querySelector("ul");
        this.tabButtons = this.tabsList.querySelectorAll("a");
        this.tabPanels = this.tabsContainer.querySelectorAll(
          ".tabs__panels > div"
        );

        this.tabsList.setAttribute("role", "tablist");

        this.tabsList.querySelectorAll("li").forEach((listitem) => {
          listitem.setAttribute("role", "presentation");
        });

        this.tabButtons.forEach((tab, index) => {
          tab.setAttribute("role", "tab");
          if (index === 0) {
            tab.setAttribute("aria-selected", "true");
          } else {
            tab.setAttribute("tabindex", "-1");
            this.tabPanels[index].setAttribute("hidden", "");
          }
        });

        this.tabPanels.forEach((panel) => {
          panel.setAttribute("role", "tabpanel");
          panel.setAttribute("tabindex", "0");
        });

        this.tabsContainer.addEventListener("click", (e) => {
          const clickedTab = e.target.closest("a");
          if (!clickedTab) return;
          e.preventDefault();

          this.switchTab(clickedTab);
        });

        this.tabsContainer.addEventListener("keydown", (e) => {
          switch (e.key) {
            case "ArrowLeft":
              e.preventDefault();
              this.moveLeft();
              break;
            case "ArrowRight":
              e.preventDefault();
              this.moveRight();
              break;
            case "Home":
              e.preventDefault();
              this.switchTab(this.tabButtons[0]);
              break;
            case "End":
              e.preventDefault();
              this.switchTab(this.tabButtons[this.tabButtons.length - 1]);
              break;
          }
        });
      }

      moveLeft() {
        const currentTab = document.activeElement;
        if (!currentTab.parentElement.previousElementSibling) {
          this.switchTab(this.tabButtons[this.tabButtons.length - 1]);
        } else {
          this.switchTab(
            currentTab.parentElement.previousElementSibling.querySelector("a")
          );
        }
      }

      moveRight() {
        const currentTab = document.activeElement;
        if (!currentTab.parentElement.nextElementSibling) {
          this.switchTab(this.tabButtons[0]);
        } else {
          this.switchTab(
            currentTab.parentElement.nextElementSibling.querySelector("a")
          );
        }
      }

      switchTab(newTab) {
        const activePanelId = newTab.getAttribute("href");
        const activePanel = this.tabsContainer.querySelector(activePanelId);

        this.tabButtons.forEach((button) => {
          button.setAttribute("aria-selected", false);
          button.setAttribute("tabindex", "-1");
        });

        this.tabPanels.forEach((panel) => {
          panel.setAttribute("hidden", true);
        });

        activePanel.removeAttribute("hidden");

        newTab.setAttribute("aria-selected", true);
        newTab.setAttribute("tabindex", "0");
        newTab.focus();
      }
    }
  );
}
